module.exports = __webpack_public_path__ + "fonts/Poppins-500-devanagari10.f43b6eb.woff2";